/* eslint-disable no-sequences */
import axios from "axios";
import { apiToken, apiUrl_forVendors } from "./constants";
const CancelToken = axios.CancelToken;

// get vendors
export let cancelGetVendorsApi;
export async function getVendors(token, query = "") {
    if (token) {
        const vendors = await axios.get(
            apiUrl_forVendors + "vendors?" + query,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
                cancelToken: new CancelToken(function executor(c) {
                    cancelGetVendorsApi = c;
                }),
            }
        );
        return vendors;
    } else {
        console.log("Please add required parameters");
    }
}

// get vendors detail
export let cancelGetVendorDetailsApi;
export async function getVendorDetails(token, id) {
    if (token && id) {
        const vendorData = await axios.get(apiUrl_forVendors + "vendor/" + id, {
            headers: {
                Authorization: `Bearer ${token}`,
                "Api-Token": apiToken,
                "Access-Token": "",
            },
            cancelToken: new CancelToken(function executor(c) {
                // An executor function receives a cancel function as a parameter
                cancelGetVendorDetailsApi = c;
            }),
        });
        return vendorData;
    } else {
        console.log("Please add required parameters");
    }
}

// add vendors
export let cancelAddVendorApi;
export async function addVendor(token, vendorsData) {
    if ((token, vendorsData)) {
        const vendors = await axios.post(
            apiUrl_forVendors + "vendor",
            vendorsData,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    cancelAddVendorApi = c;
                }),
            }
        );
        return vendors;
    } else {
        console.log("Please add required parameters");
    }
}

// update vendors
export let cancelEditVendorApi;
export async function editVendor(token, vendorData) {
    if ((token, vendorData)) {
        const vendors = await axios.put(
            apiUrl_forVendors + "vendor/" + vendorData.vendor_id,
            vendorData,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    cancelEditVendorApi = c;
                }),
            }
        );
        return vendors;
    } else {
        console.log("Please add required parameters");
    }
}

// delete vendors
export let cancelDeleteVendorApi;
export async function deleteVendor(token, id) {
    if (token && id) {
        const vendors = await axios.delete(
            apiUrl_forVendors + "vendor/" + id,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelDeleteVendorApi = c;
                }),
            }
        );
        return vendors;
    } else {
        console.log("Please add required parameters");
    }
}
